import React, { Component } from 'react';
import Snowfall from "react-snowfall";

import "./AdventCalendar.css";
import AdventCalendarDoor, { isOpenable } from './AdventCalendarDoor';
import { AdventCalendarEntry } from '../types';
import PresentDialog from './PresentDialog';
import { RANDOM_SEED } from '../constants';

interface AdventCalendarState {
  unlocked: number[],
  present?: AdventCalendarEntry;
}

interface AdventCalendarProps {
  calendar: AdventCalendarEntry[];
}

function pseudo_random(value: number, seed: number) {
  var x = Math.sin((value + 1) * seed) * 10000;
  return x - Math.floor(x);
}

class AdventCalendar extends Component<AdventCalendarProps, AdventCalendarState> {
  constructor(props: AdventCalendarProps) {
    super(props);

    // props.calendar.sort((a, b) => (a.door > b.door ? 1 : -1));
    props.calendar.sort((a, b) => (pseudo_random(a.door, RANDOM_SEED) > pseudo_random(b.door, RANDOM_SEED) ? 1 : -1));

    this.state = {
      unlocked: JSON.parse(window.localStorage.getItem("calendar_2023") || "[]") || [],
      // present: props.calendar[2]
    };
  }

  open_pane(item: AdventCalendarEntry) {
    if (isOpenable(item)) {
      if (this.state.unlocked.indexOf(item.door) < 0) {
        this.state.unlocked.push(item.door);
        this.forceUpdate();
      } else {
        this.state.unlocked.splice(this.state.unlocked.indexOf(item.door), 1);
        this.forceUpdate();
      }
    }
    window.localStorage.setItem('calendar_2023', JSON.stringify(this.state.unlocked));
  }

  render() {
    return (
      <div className="AdventCalendar">
        <main>
          <h1>ADVENT CALENDAR</h1>
          {this.props.calendar.map((item) => (
            <AdventCalendarDoor
              key={item.door}
              item={item}
              open={this.state.unlocked.indexOf(item.door) >= 0}
              onDoorClick={(item) => this.open_pane(item)}
              onContentClick={(item) => this.setState({ present: item })}
            />
          ))}
        </main>
        {this.state.present && (
          <PresentDialog present={this.state.present} onClose={() => this.setState({ present: undefined })} />
        )}
        <Snowfall style={{ zIndex: 1000000, position: "fixed" }} />
      </div>
    );
  }
}

export default AdventCalendar;
